import './goldenstar/style';
import FormStructure from './goldenstar/form_structure';

export default FormStructure;